import type { TagRequest } from '@/api-client/data/model';
import type { GlobalVariable } from '@/dashboard/features/globalVariables/domain/globalVariable.types';
import type { TreeVarFilterDataForView } from '@/dashboard/features/globalVariables/components/globalVarFilter/types/globalVarFilter.type';
import { BROKER_CONFIG } from './constants';

/**
 * Cluster 위젯은 단일 cubrid_broker 타겟만으로는 클러스터를 그릴 수 없으므로,
 * meta-target-column 요청 tags 배열에서 cubrid_broker 관련 태그를 제외한다.
 *
 * 제외 대상:
 *  1) 직접 cubrid_broker tagKey
 *  2) cubrid_broker 타입을 참조하는 표준 글로벌 변수 (tagType === 'globalVariable')
 *  3) cubrid_broker objectType(leaf)을 참조하는 트리 글로벌 변수 (tagType === 'treeGlobalVariable')
 */
export const filterClusterBrokerTags = (
  tags: TagRequest[],
  standardVariables: GlobalVariable[],
  treeVariables: TreeVarFilterDataForView[],
): TagRequest[] => {
  return tags.filter((tag) => {
    if (tag.tagKey === BROKER_CONFIG.TYPE) return false;

    if (tag.tagType === 'globalVariable' && tag.tagValue?.length) {
      const gvId = Number(tag.tagValue[0]);
      if (Number.isFinite(gvId)) {
        const variable = standardVariables.find((v) => v.globalFilterId === gvId);
        if (variable?.tagKey === BROKER_CONFIG.TYPE) return false;
      }
    }

    if (tag.tagType === ('treeGlobalVariable' as TagRequest['tagType']) && tag.tagValue?.length) {
      const tvId = Number(tag.tagValue[0]);
      if (Number.isFinite(tvId)) {
        const treeVar = treeVariables.find((v) => v.id === tvId);
        if (treeVar?.objectType === BROKER_CONFIG.TYPE) return false;
      }
    }

    return true;
  });
};
